import React from 'react'
import logo from '../../img/regenbogen-logo.jpg'

const styles = {
    header: {
        padding: '1em', 
       
    }
}
const Header = ()=> {
    return (
        <div style={styles.header}>
            <img alt='LOGO' id='logo' src={logo} />
        </div>
    )
}
export default Header


// WEBPACK FOOTER //
// ./src/Components/App/Header.js